// extracted by mini-css-extract-plugin
module.exports = {"wrap":"EditProjectContainer_wrap__2ZVpV","title":"EditProjectContainer_title__3CkOj","loader":"EditProjectContainer_loader__3SU0K"};